import {
  Typography,
  Box,
  Card,
  CardHeader,
  CardContent,
  CardMedia,
} from "@material-ui/core";
import React from "react";
import Footer from "./Footer";
import Header from "./Header";

const imageLocation = process.env.REACT_APP_API_IMAGE;

const DrugTestOrder = ({ formheader, orderDetails }) => {
  return (
    <>
      <Card variant="outlined">
        <Box display="flex" justifyContent="center">
          <Box mt={2}>
            {formheader && (
              <CardMedia
                style={{ width: 70 }}
                component={"img"}
                src={`${imageLocation}laboratory/logo/${formheader.logo}`}
              />
            )}
          </Box>
          <Box>
            <CardHeader
              component={Box}
              align="center"
              title={
                formheader && (
                  <strong style={{ fontWeight: "bolder", color: "#000" }}>
                    {formheader.name}
                  </strong>
                )
              }
              subheader={
                <Box>
                  <Typography style={{ fontWeight: "bolder", color: "#000" }}>
                    {formheader && formheader.address}
                  </Typography>
                  <Typography style={{ fontWeight: "bolder", color: "#000" }}>
                    {formheader && formheader.contact_number}
                  </Typography>
                </Box>
              }
            />
          </Box>
        </Box>

        {/* <CardContent>
          <Header details={orderDetails} />
        </CardContent> */}

        <CardContent>
          <Box>
            <Header details={orderDetails} />
          </Box>
          <Box>
            <Typography variant="h6" align="center">
              <span
                contentEditable={true}
                suppressContentEditableWarning={true}
                style={{ fontWeight: "bolder", color: "#000" }}
              >
                DRUG TEST
              </span>
            </Typography>
          </Box>

          <Box>
            {/* order details */}
            <Box>
              {orderDetails.ready ? (
                orderDetails.data.length > 0 ? (
                  orderDetails.data.map((data, key) => {
                    return (
                      <Box my={2} key={key}>
                        <Box
                          mb={3}
                          hidden={!Boolean(parseInt(data.two_panels))}
                        >
                          <Box display="flex">
                            <Box flexGrow={1}>
                              <Typography
                                variant="subtitle1"
                                style={{ fontWeight: "bolder", color: "#000" }}
                              >
                                DRUG TEST (2 PANELS)
                              </Typography>
                            </Box>
                          </Box>

                          {Boolean(parseInt(data.is_processed)) && (
                            <Box my={1}>
                              <Typography
                                style={{
                                  whiteSpace: "pre-line",
                                  fontWeight: "bolder",
                                  color: "#000",
                                }}
                              >
                                {data.two_panels_result}
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        <Box
                          mb={3}
                          hidden={!Boolean(parseInt(data.three_panels))}
                        >
                          <Box display="flex">
                            <Box flexGrow={1}>
                              <Typography
                                variant="subtitle1"
                                style={{ fontWeight: "bolder", color: "#000" }}
                              >
                                DRUG TEST (3 PANELS)
                              </Typography>
                            </Box>
                          </Box>

                          {Boolean(parseInt(data.is_processed)) && (
                            <Box my={1}>
                              <Typography
                                style={{
                                  whiteSpace: "pre-line",
                                  fontWeight: "bolder",
                                  color: "#000",
                                }}
                              >
                                {data.three_panels_result}
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        <Box
                          mb={3}
                          hidden={!Boolean(parseInt(data.five_panels))}
                        >
                          <Box display="flex">
                            <Box flexGrow={1}>
                              <Typography
                                variant="subtitle1"
                                style={{ fontWeight: "bolder", color: "#000" }}
                              >
                                DRUG TEST (5 PANELS)
                              </Typography>
                            </Box>
                          </Box>

                          {Boolean(parseInt(data.is_processed)) && (
                            <Box my={1}>
                              <Typography
                                style={{
                                  whiteSpace: "pre-line",
                                  fontWeight: "bolder",
                                  color: "#000",
                                }}
                              >
                                {data.five_panels_result}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    );
                  })
                ) : (
                  <Box>
                    <Typography color="secondary">No record found.</Typography>
                  </Box>
                )
              ) : (
                <Box>
                  <Typography color="primary">
                    Loading, Please wait...
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>

          <Box my={3} align="center">
            <Footer formheader={formheader} orderDetails={orderDetails} />
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default DrugTestOrder;
